import { discontinuedIncomePages } from './discontinuedIncomePages';

export default {
  title: 'Discontinued income',
  pages: discontinuedIncomePages,
};
